import Vue from 'vue'
// 全局fliters
// 判空
Vue.filter('isEmpty', (value) => {
  if (value === null || value === undefined) {
    return ''
  }
  return value
})
